//
import { RFormFields } from '@/components/reusable_components/next'
import { RequiredRule } from '@/mixins/reusable_mixins/rules'
import BankModel from '@/models/General/GBank'
import ProviderModel from '@/models/Purchase/PchProvider'
import TypeAccountBankModel from '@/models/General/GTypeAccountBank'

//
export default RFormFields
  .from([
    {
      name: 'pch_provider_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'rut',
        itemValue: 'id',
        label: 'Rut',
        model: ProviderModel,
        noDataText: 'Sin proveedores.',
        noObject: true,
      },
    },
    {
      name: 'pch_provider_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'alias_name',
        itemValue: 'id',
        label: 'Proveedor',
        model: ProviderModel,
        noDataText: 'Sin proveedores.',
        noObject: true,
      },
    },
    {
      name: 'g_bank_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'bank',
        itemValue: 'id',
        label: 'Banco',
        model: BankModel,
        noDataText: 'Sin bancos.',
        noObject: true,
        paramSearch: 'bank',
      },
    },
    {
      name: 'account_number',
      type: 'text-field',
      props: {
        label: 'Numero de cuenta',
        rules: [RequiredRule],
      },
    },
    {
      name: 'g_type_account_bank_id',
      type: 'autocomplete-model',
      props: {
        itemText: 'type',
        itemValue: 'id',
        label: 'Tipo de cuenta',
        model: TypeAccountBankModel,
        noDataText: 'Sin tipos de cuenta de banco.',
        noObject: true,
        paramSearch: 'type',
      },
    },
    {
      name: 'email',
      type: 'text-field',
      flex: {
        xs12: true,
        md6: true,
      },
      props: {
        label: 'Correo electrónico',
        rules: [RequiredRule],
      },
    },
  ])
